// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Column",
    children: /*#__PURE__*/_jsx("path", {
      d: "M19.5 2h-7C10.57 2 9 3.57 9 5.5v21c0 1.93 1.57 3.5 3.5 3.5h7c1.93 0 3.5-1.57 3.5-3.5v-21C23 3.57 21.43 2 19.5 2m0 3.5v8.75h-7V5.5zm-7 21v-8.75h7v8.75z"
    })
  });
};